import type { ColumnNameAndWidthI } from "~/types/table.type";

/**
 * Calculate and return the min width of an HTML table by additionning the width of each columns
 * Only consider the displayed columns if provided
 * @param columnsNameAndWidth
 * @param displayedColumns
 * @returns
 */
export function calculateTableMinWidth<T>(
  columnsNameAndWidth: ColumnNameAndWidthI<T>[],
  displayedColumns?: T[],
): string | undefined {
  let tableMinWidth: number = 0;
  if (!displayedColumns) {
    columnsNameAndWidth.forEach(
      (columnNameAndWidth: ColumnNameAndWidthI<T>) => {
        tableMinWidth += columnNameAndWidth.width ?? 0;
      },
    );
  } else {
    displayedColumns.forEach((column: T) => {
      tableMinWidth +=
        columnsNameAndWidth.find(
          (columnNameAndWidth: ColumnNameAndWidthI<T>) => {
            return columnNameAndWidth.columnName === column;
          },
        )?.width ?? 0;
    });
  }

  return tableMinWidth > 0 ? `${tableMinWidth}rem` : undefined;
}

/**
 * Return the width string value in REM of a column from a column list by its name
 * @param columnName
 * @param columnsNameAndWidth
 * @returns
 */
export function getColumnWidth<T>(
  columnName: T,
  columnsNameAndWidth: ColumnNameAndWidthI<T>[],
): string | undefined {
  const columnWidth = columnsNameAndWidth.find(
    (column) => column.columnName === columnName,
  )?.width;
  return columnWidth ? `${columnWidth}rem` : undefined;
}

/**
 * Parse a width string and return the width value
 * Example: "7.6rem" => 7.6
 * @param width
 * @returns
 */
export function parseColumnWidth(width: string): number | undefined {
  const widthValueAsString = width.replace(/[^0-9.]/g, "");
  const widthValueAsNumber = Number(widthValueAsString);
  return isNaN(widthValueAsNumber) ? undefined : widthValueAsNumber;
}
